import PropTypes from 'prop-types';
import { Text } from '@bevy/bevy-design-system';

import styles from './styles.module.less';

const Banner = ({ message, actions }) => (
  <div className={styles.banner}>
    <div className={styles.content}>
      <Text varaint='helper' size='xsmall'>
        {message}
      </Text>
      <div className={styles.actions}>
        {actions.map(({ label, dataHelpId, href }) => (
          <a key={label} href={href} data-help-id={dataHelpId} className={styles.bannerAction}>
            {label}
          </a>
        ))}
      </div>
    </div>
  </div>
);

Banner.propTypes = {
  message: PropTypes.string,
  actions: PropTypes.array,
};

export default Banner;
